import React, { useEffect, useState } from 'react';
import styles from './ProgressModal.module.css';
import useTheme from 'config/useTheme';

const ProgressModal = ({ loading, stepInterval }) => {
    const { dark } = useTheme();
    const [progress, setProgress] = useState(0);
    const [message, setMessage] = useState("");
    let interval;

    useEffect(() => {
        if (loading) {
            if (progress == 0) interval = setInterval(() => {
                setProgress((prev) => {
                    if (prev < 99) {
                        return prev + 1;
                    } else {
                        clearInterval(interval); // Clear the interval when reaching 90%
                        return prev;
                    }
                });
            }, stepInterval || 500);
        } else if (progress > 0) {
            setProgress(100);
            if (interval) clearInterval(interval);
            setTimeout(() => {
                setProgress(0);
            }, 1600);
        }

        return () => {
            clearInterval(interval);
        };
    }, [loading]);

    useEffect(() => {
        if (progress < 60) {
            setMessage("Please wait...");
        } else {
            setMessage("Almost there!");
        }
    }, [progress]);

    return (
        <div className={`${dark ? styles.dark : ""} ${styles.component}`}>
            <div className={styles.label}>{message}</div>
            <span>In progress...</span>
            <div className={styles.progress_bar}>
                <div className={styles.progress} style={{ width: `${progress}%` }}></div>
            </div>
        </div>
    )
}

export default ProgressModal;